import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#192533\" cx=\"10\" cy=\"10\" r=\"10\"></circle><g fill-rule=\"nonzero\"><path d=\"M11.608 12.19v-2.095H9.453V8h4.31v4.19h-2.155zm2.155-6.285H7.298v6.285H5.143V3.81h8.62v2.095z\" fill=\"#87ABC5\"></path><path fill=\"#87ABC5\" d=\"M13.763 13.029v1.257H7.298V12.19h4.31v-.942h2.155z\"></path><path fill=\"#FFF\" d=\"M15.918 5.905V8h-2.155V5.905z\"></path><path fill=\"#1D252E\" d=\"M7.298 12.19v2.096H5.143V12.19z\"></path><path fill=\"#F07F53\" d=\"M7.298 14.286v2.095H5.143v-2.095z\"></path></g></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}